<template>
	<v-layout row wrap>
		<v-flex xs12>
			<v-card>
				<v-card-text>
				   <v-tabs
				    centered
				    color="indigo"
				    
				    icons-and-text
				  >
				    <v-tabs-slider color="green"></v-tabs-slider>
				    <v-tab href="#tab-1">
				      Status
				      <v-icon>fas fa-chart-area</v-icon>
				    </v-tab>

				    <v-tab href="#tab-2">
				      Informe
				      <v-icon>fas fa-chart-pie</v-icon>
				    </v-tab>

				    <v-tab href="#tab-3">
				      Datos
				      <v-icon>fas fa-table</v-icon>
				    </v-tab>

				    <v-tab-item
				      :value="'tab-1'"
				    >
				      <v-card text>
				        <v-card-text>
				        	<v-layout row wrap justify-center>
				        		<v-flex xs12>
				        		 <h3 class="text-md-center">Ciclo de procesamiento #{{ cicle }}</h3>
				        		</v-flex>
				        		<v-flex xs12 class="text-md-center">			        		  
									      <v-btn color="success" icon @click="getStatus()">
									        <v-icon>fas fa-check-square</v-icon>
									      </v-btn>
									      <v-btn color="info" icon @click="executeStep(0)"  :loading="loading"
      											:disabled="loading" >
									        <v-icon >fas fa-play</v-icon>
									      </v-btn>
									      <v-btn color="success"  :disabled="habilitedCicle" icon @click="plusCicle()">
									        <v-icon>fas fa-plus</v-icon>
									      </v-btn>
				        		</v-flex>
		        			  <v-progress-linear :value="20" indeterminate :active="loadingDataSet"></v-progress-linear>
					        	<v-flex v-if="dataParent.sub_proccess == 1" xs12 >
					        		<v-layout row wrap justify-center>
					        		  <v-flex class="text-md-center text-xs-center" 
					        		  	:xs3="steps.status.length == 4" 
					        		  	:xs4="steps.status.length == 3" 
					        		  	:xs6="steps.status.length == 2" 
					        		  	:xs12="steps.status.length == 1" 
					        		  	v-for="step in steps.status">
						        			<v-card>
						        				<v-card-title class="text-md-center text-xs-center" primary-title>
						        		  		<h4>{{ step.title }}</h4>
						        				</v-card-title>
						        			  <v-card-text>
						        			  	<v-layout row wrap justify-center>
						        			  	  <v-flex xs12 class="text-md-center text-xs-center">				        			  	    
										        		  <v-progress-circular
										        		  :rotate="-90"
														      :size="100"
														      :width="15"
														      color="indigo"
															    :indeterminate="step.indeterminate" 
															    :value="step.percent" 
															    >
															    	<v-btn text 
															    		fab small 
															    		:loading="loading"
      																:disabled="loading" 
															    		@click="executeStep(0)">
															    		<v-icon color="black">fas fa-play</v-icon>
															    	</v-btn>
															    </v-progress-circular>
						        			  	  </v-flex>
						        			  	</v-layout>
						        			  </v-card-text>
						        			</v-card>
					        		  </v-flex>
					        		</v-layout>
					        	</v-flex>
					        	<v-flex xs12 v-if="dataParent.sub_proccess == 0">
				        			<v-expansion-panel v-model="panel">
										    <v-expansion-panel-content 
										     	v-for="subProccess in steps.datasets"
										      :key="subProccess.id"
										    >
										      <template v-slot:header >
										        <div>Sub proceso nivel: {{ subProccess.level }}</div>
										      </template>
										      <v-card>
										      	<v-btn text 
											    		fab small 
											    		:loading="loading"
															:disabled="loading" 
											    		@click="executeSubProccess(subProccess.id)">
											    		<v-icon color="black">fas fa-play</v-icon>
											    	</v-btn>
							      				<v-progress-linear :value="20" indeterminate :active="loadingSubProccess"></v-progress-linear>
							      				<v-layout row wrap justify-center>
								        		  <v-flex class="text-md-center text-xs-center" 
								        		  	:xs3="currentSubProccess.length == 4" 
								        		  	:xs4="currentSubProccess.length == 3" 
								        		  	:xs6="currentSubProccess.length == 2" 
								        		  	:xs12="currentSubProccess.length == 1" 
								        		  	v-for="step in currentSubProccess">
													      <v-card>
													      	<v-card-title primary-title>
									        		  		<h4>{{ step.title }}</h4>
									        				</v-card-title>
									        			  <v-card-text>
									        		  		{{ step.proccess }} / {{ step.total }}
									        			  </v-card-text>
									        			  <v-card-actions class="text-md-center text-xs-center">
									        			  	<v-layout row wrap justify-center>
									        			  	  <v-flex xs12 class="text-md-center text-xs-center">				        			  	    
													        		  <v-progress-circular
													        		  :rotate="-90"
																	      :size="100"
																	      :width="15"
																	      color="indigo"
																		    :indeterminate="step.indeterminate" 
																		    :value="step.percent" 
																		    >
																		    	<v-btn text 
																		    		fab small 
																		    		:loading="loading"
			      																:disabled="loading" 
																		    		@click="executeSubStep(step, subProccess.id)">
																		    		<v-icon color="black">fas fa-play</v-icon>
																		    	</v-btn>
																		    </v-progress-circular>
									        			  	  </v-flex>
									        			  	</v-layout>
									        		 		</v-card-actions>
																	<v-card-actions class="text-md-center text-xs-center">
									        			  	<v-layout row wrap >
									        			  	  <v-flex xs4>
									        			  	  	<v-btn fab text small color="red" @click="computeSteperCicle(step.cicleTile, '-')"><v-icon color="red">far fa-minus-square</v-icon></v-btn>
									        			  	  </v-flex>
									        			  	  <v-flex xs4 >
									        			  	  	<label >Cicle</label><br>
									        			  	  	{{stepCicle[step.cicleTile]}}
									        			  	  </v-flex>
									        			  	  <v-flex xs4>
									        			  	  	<v-btn fab small text color="blue" @click="computeSteperCicle(step.cicleTile, '+')"><v-icon color="blue">far fa-plus-square</v-icon></v-btn>
									        			  	  </v-flex>
									        			  	</v-layout>
									        		 		</v-card-actions>
									        			</v-card>
									        		</v-flex>
									        	</v-layout>
										      </v-card>
										    </v-expansion-panel-content>
										  </v-expansion-panel>
					        	</v-flex>
				        	</v-layout>
				        </v-card-text>
				      </v-card>
				    </v-tab-item>
				    <v-tab-item :value="'tab-2'">
				      <v-card text>
				        <v-card-text>
				        	<v-layout row wrap>
				        		<v-flex xs12>
				        		  <v-layout row wrap>
				        		    <v-flex xs6 pa-1>
				        		    	<label for="">Proceso</label>
				        		      <v-autocomplete
				        		        name="name" solo @change="getInformVars()"
				        		        label="Proceso" v-model="informFilters.id_dataset"
				        		        id="id" :items="steps.datasets"
				        		        item-text="name" item-value="id"
				        		      ></v-autocomplete>
				        		    </v-flex>
				        		    <v-flex xs6 pa-1>
				        		    	<label for="">Tipo de informe</label>
				        		      <v-autocomplete
				        		      	:items="[{text: 'Punto', value:'point'}, {text: 'Variables', value:'variable'}]"
				        		        name="name" solo v-model="informFilters.type" @change="getStadistics()"
				        		        label="Filtrar por:"

				        		        id="id" 
				        		      ></v-autocomplete>
				        		    </v-flex>
				        		    <v-flex xs6 pa-1>
				        		    	<label for="">Variables</label>
				        		      <v-autocomplete
				        		      	:items="informData.variables" @change="getStadistics()"
				        		        name="name" solo v-model="informFilters.id_variable"
				        		        label="Filtrar por:"
				        		        item-text="name" item-value="id"
				        		        id="id"
				        		      ></v-autocomplete>
				        		    </v-flex>
				        		    <v-flex xs6 pa-1>
				        		    	<label>Puntos</label>
				        		      <v-autocomplete
				        		      	:items="informData.points" @change="getStadistics()"
				        		        name="name" solo v-model="informFilters.id_point"
				        		        label="Filtrar por:"
				        		        item-text="name" item-value="id"
				        		        id="id"
				        		      ></v-autocomplete>
				        		    </v-flex>
				        		  </v-layout>
				        		</v-flex>
				        		<v-flex xs12>
				        		  <v-data-table
						        	  :headers="informTable.headers"
						        	  :items="informTable.items"
						        	  class="elevation-1"
						        	  pagination.sync="pagination"
						        	  item-key="id"
						        	>
						        	  <template v-slot:items="props" >
								 	 	 	   		<tr>
									 	 	 	   		<td>{{ props.item.id }}</td>
									 	 	 	   		<td>{{ props.item.name }}</td>
									 	 	 	   		<td>{{ props.item.proccess }}</td>
									 	 	 	   		<td>{{ props.item.unproccess }}</td>
									 	 	 	   		<td>{{ props.item.total }}</td>
								 	 	 	   		</tr>
								 	 	 	   	</template>
						        	</v-data-table>
				        		</v-flex>
				        	</v-layout>
				        </v-card-text>
				      </v-card>
				    </v-tab-item>
				    <v-tab-item
				      :value="'tab-3'"
				    >
				      <v-card text>
				        <v-card-text>
				        	 <v-layout row wrap>
		        		    <v-flex xs4 pa-1>
		        		    	<label for="">Proceso</label>
		        		      <v-autocomplete
		        		        name="name" solo @change="getDataVars()"
		        		        label="Proceso" v-model="dataFilters.dataset_object"
		        		        id="id" :items="steps.datasets"
		        		        item-text="name" return-object
		        		      ></v-autocomplete>
		        		    </v-flex>
		        		    <v-flex xs4 pa-1>
		        		    	<label for="">Variables</label>
		        		      <v-autocomplete
		        		      	:items="informData.variables" @change="getStadistics()"
		        		        name="name" solo v-model="dataFilters.id_variable"
		        		        label="Filtrar por:"
		        		        item-text="name" item-value="id"
		        		        id="id"
		        		      ></v-autocomplete>
		        		    </v-flex>
		        		    <v-flex xs4 pa-1>
		        		    	<label>Puntos</label>
		        		      <v-autocomplete
		        		      	:items="informData.points" @change="getStadistics()"
		        		        name="name" solo v-model="dataFilters.id_point"
		        		        label="Filtrar por:"
		        		        item-text="name" item-value="id"
		        		        id="id"
		        		      ></v-autocomplete>
		        		    </v-flex>
		        		  </v-layout>
		        		  <v-layout row wrap>
		        		    <v-flex xs6>
		        		    	<label for="">Fecha inicial</label>
		        		      <v-menu
										    ref="menu1"
										    v-model="menu1"
										    :close-on-content-click="false"
										    :nudge-right="0"
										    lazy
										    transition="scale-transition"
										    offset-y
										    full-width
										    min-width="290px"
										  >
										    <template v-slot:activator="{ on }">
										      <v-text-field
										        v-model="dataFilters.date_init"
										        label="Fecha de inicio"
										        prepend-icon="mdi-event"
										        readonly solo
										        v-on="on"
										      ></v-text-field>
										    </template>
										    <v-date-picker
										      ref="picker"
										      v-model="dataFilters.date_init"
										      :max="dataFilters.dataset_object.end"
										      :min="dataFilters.dataset_object.init"
										      @change="save1" dark
										    ></v-date-picker>
										  </v-menu>
		        		    </v-flex>
		        		    <v-flex xs6>
		        		    	<label for="">Fecha final</label>
		        		      <v-menu
										    ref="menu2"
										    v-model="menu2"
										    :close-on-content-click="false"
										    :nudge-right="40"
										    lazy
										    transition="scale-transition"
										    offset-y
										    full-width
										    min-width="290px"
										  >
										    <template v-slot:activator="{ on }">
										      <v-text-field
										        v-model="dataFilters.date_end"
										        label="Ficha final"
										        prepend-icon="mdi-event"
										        readonly solo
										        v-on="on"
										      ></v-text-field>
										    </template>
										    <v-date-picker
										      ref="picker"
										      v-model="dataFilters.date_end" dark
										      :max="dataFilters.dataset_object.end"
										      :min="dataFilters.dataset_object.init"
										      @change="save2"
										    ></v-date-picker>
										  </v-menu>
		        		    </v-flex>
		        		  </v-layout>
	        		    <v-btn color="indigo" @click="getDataDataTable()">Filtrar</v-btn>
		        		  <v-card>
		        		    <v-card-title primary-title>
		        		     	<v-layout row wrap>
		        		     	  <v-flex xs4>
		        		     	    Valor maximo: {{ dataTable.max }}
		        		     	  </v-flex>
		        		     	  <v-flex xs4>
		        		     	    Valor minimo: {{ dataTable.min }}
		        		     	  </v-flex>
		        		     	  <v-flex xs4>
		        		     	    Promedio: {{ dataTable.average }}
		        		     	  </v-flex>
		        		     	  <v-flex xs12>
		        		     	    <v-text-field
		        		     	      name="search"
		        		     	      label="Buscar..."
														v-model="dataTable.search"
		        		     	    ></v-text-field>
		        		     	  </v-flex>
		        		     	</v-layout>
		        		    </v-card-title>
		        		    <v-card-text>
		        		       <v-data-table
						        	  :headers="dataTable.headers"
						        	  :items="dataTable.items"
						        	  class="elevation-1"
						        	  pagination.sync="pagination"
						        	  item-key="id"
						        	  :search="dataTable.search"
						        	>
						        	  <template v-slot:items="props" >
								 	 	 	   		<tr>
									 	 	 	   		<td>{{ props.item.id }}</td>
									 	 	 	   		<td>{{ props.item.name }}</td>
									 	 	 	   		<td>{{ props.item.type }}</td>
									 	 	 	   		<td>{{ props.item.extract_date }}</td>
									 	 	 	   		<td>{{ props.item.value }}</td>
									 	 	 	   		<td>{{ props.item.original }}</td>
								 	 	 	   		</tr>
								 	 	 	   	</template>
						        	</v-data-table>
		        		    </v-card-text>
		        		  </v-card>
				      	</v-card-text>
				      </v-card>
				    </v-tab-item>
				  </v-tabs>
				</v-card-text>
				<v-card-actions>
					<v-btn color="success" @click="$emit('closeModal')">Ejecutar en segundo plano</v-btn>	      
		    </v-card-actions>	    
			</v-card>	  		  
		</v-flex>
	</v-layout>
</template>
<script>
	export default {
		created() {
			this.defineWeeks();
		},
		mounted(){
			this.getStatus();
		},
		props: [
			'dataParent'
		],
		data(){
			return {
					baseRoute: process.env.VUE_APP_URL + 'api/gis/',
					pythonBaseRoute: 'http://127.0.0.1:8000/gis',
					interval: {},
					step: 1,
					cicle: 1,
					loading: false,
					steps: [],
					panel: [],
					currentSubProccess: [],
					loadingSubProccess: false,
					informData: [
						{
							title: 'Datos Brutos procesados',
							values: [
								{ label: 'Total de semanas: ', value: 0 },
								{ label: 'Valores asignados: ', value: 0 },
								{ label: 'Semanas faltantes: ', value: 0 },
								{ label: 'Porcentaje de error: ', value: 0 },
							]
						},
						{
							title: 'Datos reasignados',
							values: [
								{ label: 'Total de semanas: ', value: 0 },
								{ label: 'Valores asignados: ', value: 0 },
								{ label: 'Semanas faltantes: ', value: 0 },
								{ label: 'Porcentaje de error: ', value: 0 },
							]
						},
						{
							title: 'Datos calculados',
							values: [
								{ label: 'Total de semanas: ', value: 0 },
								{ label: 'Valores asignados: ', value: 0 },
								{ label: 'Semanas faltantes: ', value: 0 },
								{ label: 'Porcentaje de error: ', value: 0 },
							]
						}

					],
					loadingDataSet: false,
					habilitedCicle: true,
					currentDataset: '',
					weeks: [],
					stepCicle: {
						first: 0,
						second: 0,
						third: 0,
						fourt: 0,
						five: 0,
						six: 0	
					},
					informFilters: {
						type: 'point',
						id_dataset: '',
						id_variable: '',
						id_point: '',
					},
					informData: {
						variables: [],
						points: []
					},
					informTable: {
						headers: [
						{
								sortable: true,
								text: 'Id',
								value: 'id'
							},
							{
								sortable: true,
								text: 'Nombre',
								value: 'name'
							},
							{
								sortable: true,
								text: 'Procesados',
								value: 'proccess'
							},
							{
								sortable: true,
								text: 'No procesados',
								value: 'unproccess'
							},
							{
								sortable: true,
								text: 'total',
								value: 'total'
							},
						],
						items: []
					},
					dataFilters: {
						dataset_object: {},
						id_dataset: '',
						id_variable: '',
						id_point: '',
						date_init: '',
						date_end: '',
					},
					dataTable: {
						headers: [
							{
								sortable: true,
								text: 'Id',
								value: 'id'
							},
							{
								sortable: true,
								text: 'Nombre',
								value: 'name'
							},
							{
								sortable: true,
								text: 'Tipo',
								value: 'type'
							},
							{
								sortable: true,
								text: 'Fecha',
								value: 'extract_date'
							},
							{
								sortable: true,
								text: 'Valor',
								value: 'value'
							},
							{
								sortable: true,
								text: 'Ciclo',
								value: 'original'
							},
						],
						items: [],
						max: '',
						min: '',
						average: '',
					},
					menu1: false,
					menu2: false,
			}
		},
		watch: {
			panel: function(){
				this.currentSubProccess = [];
				if(this.panel != null){
					this.currentDataset = this.steps.datasets[this.panel].id;
					this.getStatusSubProccess(this.steps.datasets[this.panel].id);
				}
			},
			dataParent: function(){
				this.getStatus();
				this.cicle = 1;
				this.step = 1;
				this.steps = [];
			},
			menu1 (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
      menu2 (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
		},
		methods: {
			plusCicle(){
				if(this.cicle < 9){
					this.cicle++;
					this.step = 1;
					this.habilitedCicle = true;
				}
			},
			getDataset(){	
				axios.get(this.baseRoute + 'proccess/getDataset?id=' + this.dataParent.id).then((res) => {
					this.dataSetData = res.data;
				}).catch((error) => {
					this.$emit('serverDump', 'Hubó un error interno en el servidor por favor vuelva a intentarlo')
				});
			},
			executeStep(step){
				this.loading = true;
				//this.activeInterval();
				if(step == 0){
					axios.get(this.pythonBaseRoute + '/computeConstant?id=' + this.dataParent.id).then((res) => {

					}).catch((error) => {
						this.$emit('serverDump', 'Servicio de procesamiento de imagenes caido intente nuevamente')
					})
				}
				//axios.get(this.baseRoute + 'proccess/init?id=' + this.dataParent.id +'&step=' + step + '&cicle=' + this.cicle).then((res) => {
				//	window.clearInterval(this.interval);
				//	if(res.data != 'END'){
				//		this.loading = false;
				//	}else{
				//		this.loading = false;
				//		this.habilitedCicle = false;
				//		this.$emit('serverDump', 'Ciclo terminado')
				//	}
				//}).catch((error) => {
				//	this.loading = false;
				//	window.clearInterval(this.interval);
				//	this.$emit('serverDump', 'Hubó un error interno en el servidor por favor vuelva a intentarlo')
				//});
			},
			executeSubStep(step, dataset){
				this.loading = true;
				//this.activeInterval(1);
				axios.get(this.baseRoute + 'proccess/init?id=' + dataset +'&step=' + step.step + '&cicle=' + this.stepCicle[step.cicleTile]).then((res) => {
					window.clearInterval(this.interval);
					if(res.data != 'END'){
						this.loading = false;
					}else{
						this.loading = false;
						this.habilitedCicle = false;
						this.$emit('serverDump', 'Ciclo terminado')
					}
				}).catch((error) => {
					this.loading = false;
					window.clearInterval(this.interval);
					this.$emit('serverDump', 'Hubó un error interno en el servidor por favor vuelva a intentarlo')
				});
				if(step.step == 0){
					axios.get(this.pythonBaseRoute + '/computeConstant?id=' + dataset).then((res) => {

					}).catch((error) => {
						this.$emit('serverDump', 'Servicio de procesamiento de imagenes caido intente nuevamente')
					})
				}
			},
			executeSubProccess(dataset){
				this.loading = true;
				//this.activeInterval(1);
				if(this.step == 0){
					axios.get(this.pythonBaseRoute + '/computeConstant?id=' + dataset).then((res) => {

					}).catch((error) => {

					})
				}
				axios.get(this.baseRoute + 'proccess/init?id=' + dataset +'&step=' + this.step + '&cicle=' + this.cicle).then((res) => {
					window.clearInterval(this.interval);
					if(res.data != 'END'){
						this.loading = false;
						this.step = res.data + 1;
						setTimeout(() => (this.executeProccess()), 5000)
					}else{
						this.loading = false;
						this.habilitedCicle = false;
						this.$emit('serverDump', 'Ciclo terminado')
					}
				}).catch((error) => {
					this.step = 1;
					this.loading = false;
					window.clearInterval(this.interval);
					this.$emit('serverDump', 'Hubó un error interno en el servidor por favor vuelva a intentarlo')
				});
			},
			executeProccess(){
				this.loading = true;
				//this.activeInterval();
				axios.get(this.baseRoute + 'proccess/init?id=' + this.dataParent.id +'&step=' + this.step + '&cicle=' + this.cicle).then((res) => {
					window.clearInterval(this.interval);
					if(res.data != 'END'){
						this.loading = false;
						this.step = res.data + 1;
						setTimeout(() => (this.executeProccess()), 5000)
					}else{
						this.loading = false;
						this.habilitedCicle = false;
						this.$emit('serverDump', 'Ciclo terminado')
					}
				}).catch((error) => {
					this.step = 1;
					this.loading = false;
					window.clearInterval(this.interval);
					this.$emit('serverDump', 'Hubó un error interno en el servidor por favor vuelva a intentarlo')
				});
			},
			activeInterval(type = 0){
				window.clearInterval(this.interval);
				if(type == 1){
					this.getStatusSubProccess();
	        this.interval = window.setInterval(function(){
	        	this.getStatusSubProccess();
	        }.bind(this), 5000);
				}else{
					this.getStatus();
	        this.interval = window.setInterval(function(){
	        	this.getStatus();
	        }.bind(this), 5000);
				}
			},
			getStatus(){
				this.loadingDataSet = true;
				setTimeout(() => (
					axios.get(this.baseRoute + 'proccess/getStatus?id=' + this.dataParent.id).then((res) => {
						this.loadingDataSet = false;
						this.steps = res.data;
					}).catch((error) => {
						this.loadingDataSet = false;
						window.clearInterval(this.interval);
						this.$emit('serverDump', 'Hubó un error interno en el servidor por favor vuelva a intentarlo')
						this.step = 1;
					})
				), 5000)	
			},
			jobSecondPlane(){
				axios.get(this.baseRoute + 'proccess/executeSecondPlane').then((res) =>{
					this.$emit('closeModal');
				})	
			},
			getStatusSubProccess(val = 0){
				if(val == 0){
					var dataset = this.currentDataset
				}else{
					var dataset = val;
				}
				this.loadingSubProccess = true
				axios.get(this.baseRoute + 'proccess/getStatus?id=' + dataset).then((res) => {
					this.loadingSubProccess = false;
					this.currentSubProccess = res.data.status;
				}).catch((error) => {
					window.clearInterval(this.interval);
					this.$emit('serverDump', 'Hubó un error interno en el servidor por favor vuelva a intentarlo')
					this.step = 1;
					this.loadingSubProccess = false;
				});
			},
			defineWeeks(){
				for (var i = 0; i <= 53; i++){
					this.weeks.push(i);
				}
			},
			computeSteperCicle(step, type){
				if(type == '+'){
					this.stepCicle[step]++;
				}else{
					this.stepCicle[step]--;
				}
			},
			getInformVars(){
				axios.put(this.baseRoute + 'proccess/getDataInform', this.informFilters).then((res) => {
					this.informData = res.data;
				})
				this.getStadistics();
			},
			getStadistics(){
				axios.put(this.baseRoute + 'proccess/getStadistics', this.informFilters).then((res) => {
					this.informTable.items = res.data
				})
			},
			getDataVars(){
				this.dataFilters.id_dataset = this.dataFilters.dataset_object.id;
				axios.put(this.baseRoute + 'proccess/getDataInform', this.dataFilters).then((res) => {
					this.informData = res.data;
				});
				this.dataFilters.date_init = this.dataFilters.dataset_object.init 
				this.dataFilters.date_end = this.dataFilters.dataset_object.end
			},
			getDataDataTable(){
				console.log("Ejecutando");
				axios.put(this.baseRoute + 'proccess/getDataTable', this.dataFilters).then((res) => {
					this.dataTable.items = res.data.items;
					this.dataTable.max = res.data.max;
					this.dataTable.min = res.data.min;
					this.dataTable.average = res.data.average;
				});
			},
			save1 (date) {

        this.$refs.menu1.save(date)
      },
      save2 (date) {

        this.$refs.menu2.save(date)
      }
		}
	}
</script> 